'use client'
import { useMemo } from 'react'
import ErrorBoundary from '@error-boundary'
import dynamic from 'next/dynamic'

import type { AcfSectionWithSidebarItem } from '@typings'
import { RaImage, RaPaper, RaRichText } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'

import styles from './ra-sidebar-section.module.scss'

const RaFormWrapper = dynamic(() =>
  import('@components/form-elements/RaFormWrapper/RaFormWrapper').then(
    ({ RaFormWrapper }) => RaFormWrapper,
  ),
)

const SimpleCarousel = dynamic(() =>
  import('@components/carousels/SimpleCarousel/SimpleCarousel').then(
    ({ SimpleCarousel }) => SimpleCarousel,
  ),
)

export const RaSidebarSection = ({ section }: AcfSectionWithSidebarItem) => {
  const renderForm = useMemo(() => {
    if (!section.form || section.form?.id < 1) return null
    return (
      <RaPaper
        paddingMobile={5}
        padding={6}>
        <RaFormWrapper
          id={section.form.id}
          expires={section.form.expires}
          history={section.form.history}
          redirect={section.form.redirect}
          formData={section.form.formData}
        />
      </RaPaper>
    )
  }, [section.form])

  const renderSlides = useMemo(() => {
    if (!section.slider?.length) return null
    return Loop(section.slider, (image, i) => (
      <RaImage
        key={i}
        width={800}
        height={600}
        image={image}
      />
    ))
  }, [section.slider])

  return (
    <ErrorBoundary>
      <div className={styles['section']}>
        {section.video && <RaRichText content={section.video} />}
        {section.slider && renderSlides && <SimpleCarousel slides={renderSlides} />}
        {section.form && renderForm}
      </div>
    </ErrorBoundary>
  )
}
